import React from 'react';

const GoToIcon = () => {
  return (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.570176 2.22211L3.87166 5.99175L0.570176 9.76139C0.238327 10.1403 0.238327 10.7524 0.570176 11.1313C0.902026 11.5102 1.43809 11.5102 1.76994 11.1313L5.67556 6.67184C6.00741 6.29293 6.00741 5.68085 5.67556 5.30195L1.76994 0.842503C1.43809 0.463596 0.902026 0.463596 0.570176 0.842504C0.246835 1.22141 0.238326 1.84321 0.570176 2.22211Z" fill="#1D242E"/>
      <path d="M5.32457 2.22211L8.62605 5.99175L5.32457 9.76139C4.99272 10.1403 4.99272 10.7524 5.32457 11.1313C5.65642 11.5102 6.19249 11.5102 6.52434 11.1313L10.43 6.67184C10.7618 6.29293 10.7618 5.68085 10.43 5.30195L6.52433 0.842503C6.19249 0.463596 5.65642 0.463596 5.32457 0.842504C5.00123 1.22141 4.99272 1.84321 5.32457 2.22211Z" fill="#1D242E"/>
    </svg>
  );
};

export default GoToIcon;
